module.exports = __webpack_public_path__ + "media/images/bg/mosaic/pattern-daisy-fb9175199219998c6a20502027476497.svg";